import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { DevService } from '../dev/dev.service';

declare var Windows;

@Injectable()
export class CommsService {

	env = environment;
	appId = '';
	token = '';
	userAgent = `VantageWeb/${environment.appVersion}`;
	private serverSwitchLocalData: any;
	constructor(
		private http: HttpClient,
		private devService: DevService
	) {
	}

	public getCmsHost() {
		if (this.serverSwitchLocalData && this.serverSwitchLocalData.forceit === true) {
			return this.serverSwitchLocalData.cmsserver;
		} else {
			return this.env.cmsApiRoot;
		}
	}

	public endpointGetCall(endpoint, queryParams: any = {}, httpOptions: any = {}) {
		const url = this.getCmsHost() + endpoint;
		httpOptions.params = new HttpParams({
			fromObject: queryParams
		});

		this.devService.writeLog('API GET ENDPOINT complete: ', url + '?' + httpOptions.params);
		return this.http.get(url, httpOptions);
	}

	flatGetCall(url) {
		const self = this;
		this.devService.writeLog('FLAT GET ENDPOINT: ', url);
		return this.http.get(url);
	}

	setServerSwitchLocalData(serverSwitchLocalData) {
		this.serverSwitchLocalData = serverSwitchLocalData;
	}
}
